export default __webpack_public_path__ + "static/media/PDF_file_icon.3dfcb5cd.png";